import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";

export const Role = types
  .model({
    name: types.maybeNull(types.string),
    isDefault: types.maybeNull(types.boolean),
    isStatic: types.maybeNull(types.boolean),
    isPublic: types.maybeNull(types.boolean),
    concurrencyStamp: types.maybeNull(types.string),
    id: types.maybeNull(types.string),
    extraProperties: types.maybeNull(types.frozen<any>()),
  })
  .actions(withSetPropAction);
export interface IRole extends Instance<typeof Role> {}
export interface IRoleProperties extends SnapshotIn<typeof Role> {}
